// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-uByt","colBig":"styles_colBig__2EZCn","colSmall":"styles_colSmall__7y2fR"};